import { ChecklistMilestone, TransactionTeam, useGetChecklistMilestonesQuery } from '@repo/services';

/**
 * Loads checklist milestones and exposes helpers to sort milestone names/values by their defined `sequence`, used to order checklist-milestone columns and filters consistently across the app.
 *
 * @returns `{ getSortedMilestonesFromTransactions, sortByMilestone, sortMilestoneOptions }` helpers.
 */
export const useChecklisMilestones = () => {
    const { data: checklistMilestones = [] } = useGetChecklistMilestonesQuery(null);

    const getMilestoneMap = () => {
        const updatedMilestones = checklistMilestones.map(({ value, sequence }) => ({
            value,
            sequence
        }));

        return updatedMilestones.reduce((acc, { value, sequence }) => {
            //@ts-ignore
            acc[value] = sequence;
            return acc;
        }, {});
    }

    const sortMilestoneOptions = (options:string[] = []) => {
        const sequenceMap = getMilestoneMap();
        const filteredArr = options.filter(str => str);
        const sortedMilestoneStringArr = filteredArr.sort((a, b) => {
          const valueA = checklistMilestones?.find((m) => m?.name?.toLowerCase() === a?.toLowerCase())?.value;
          const valueB = checklistMilestones?.find((m) => m?.name?.toLowerCase() === b?.toLowerCase())?.value;
          if (valueA && valueB) {
            //@ts-ignore
            return sequenceMap[valueA] - sequenceMap[valueB]
          }
          return 0;
        });
        return sortedMilestoneStringArr;
    }

    const getSortedMilestonesFromTransactions = (transactions:TransactionTeam[] = []) => {
        const arr = [
            ...new Set(transactions.map((item) => item?.aimChecklistMilestone as string))
        ];
        return sortMilestoneOptions(arr);
    }

    const sortByMilestone = (order: 'asc' | 'desc' | 'none', aValue?: Pick<ChecklistMilestone, 'value'>, bValue?: Pick<ChecklistMilestone, 'value'>) => {
        const milestoneMap = getMilestoneMap();
        //@ts-ignore
        const aSequence = milestoneMap[aValue?.value] ?? Infinity;
        //@ts-ignore
        const bSequence = milestoneMap[bValue?.value] ?? Infinity;

        if (aValue?.value === '' || aValue === undefined) return order === 'asc' ? -1 : 1;
        if (bValue?.value === '' || bValue === undefined) return order === 'asc' ? 1 : -1;

        const comparison = order === 'asc' ? aSequence - bSequence : bSequence - aSequence;
        if (comparison !== 0) return comparison;
    }

    return {getSortedMilestonesFromTransactions, sortByMilestone, sortMilestoneOptions}
}
